import { defaultSpring } from 'shared/kanimate';

import { headerBackgroundColor, headerBorderColor } from '../../../../globals/colors';

import { iconClose } from '../../../../globals/assets';

export const staticStyles = {
  wrapper: {
    flex: '0 0 auto',
    width: '100%',
    fontWeight: '300',
    fontSize: '12px',
    display: 'flex',
    position: 'relative',
    backgroundColor: `${headerBackgroundColor}`,
    borderBottom: `1px solid ${headerBorderColor}`,
    borderRadius: '9px 9px 0 0',
  },
  close: {
    wrapper: {
      position: 'absolute',
      top: '18px',
      right: '10px',
      padding: '5px',
      borderRadius: '50%',
      cursor: 'pointer',
    },
    icon: {
      backgroundImage: `url("${iconClose}")`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: '16px',
      height: '16px',
      width: '16px',
    },
  },
};

export const start = props => {
  return {
    wrapperHeight: props.expanded ? 195 : 64,
  };
};

export const end = props => {
  return {
    wrapperHeight: defaultSpring(props.expanded ? 195 : 64),
  };
};

export const tween = animationStyles => {
  return {
    wrapper: {
      height: `${animationStyles.wrapperHeight}px`,
    },
  };
};
